import { css } from 'lit';
import { hostReset } from '../styles/mixins.js';
import * as t from '../styles/tokens.js';

export default [
  hostReset,
  css`
    :host {
      display: inline-flex;
      align-items: center;
      gap: ${t.space2};
      vertical-align: middle;
      cursor: pointer;
      user-select: none;
    }
    :host([disabled]) {
      pointer-events: none;
      opacity: 0.6;
      cursor: not-allowed;
    }

    /* ── Circle ─────────────────────────────────────────────────────────────── */
    .uwc-rb {
      /* Size derives from the global font token (×1.286 ≈ the old 1.125rem at
         the 0.875rem default) so the radio rescales with the size/font presets.
         A theme can still pin an exact size via --uwc-radio-size. */
      --_size:        var(--uwc-radio-size,   calc(var(--uwc-font-size-md, 0.875rem) * 1.286));
      --_dot-size:    calc(var(--_size) * 0.45);
      --_border:      var(--uwc-radio-border, 1px solid ${t.borderControl});
      --_bg:          var(--uwc-radio-bg,     ${t.surface});
      --_color:       var(--uwc-radio-color,  var(--uwc-color-primary, ${t.primary}));

      position: relative;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width:         var(--_size);
      height:        var(--_size);
      flex-shrink:   0;
      border:        var(--_border);
      border-radius: 50%;
      background:    var(--_bg);
      transition:
        background-color ${t.durationBase},
        border-color     ${t.durationBase},
        box-shadow       ${t.durationBase};
    }

    /* Hidden native radio */
    input[type="radio"] {
      position: absolute;
      inset: 0;
      opacity: 0;
      width: 100%;
      height: 100%;
      margin: 0;
      cursor: pointer;
    }

    /* Checked state */
    :host([checked]) .uwc-rb {
      border-color: var(--_color);
    }

    /* Inner dot */
    .uwc-rb__dot {
      width:         var(--_dot-size);
      height:        var(--_dot-size);
      border-radius: 50%;
      background:    var(--_color);
      transform:     scale(0);
      transition:    transform ${t.durationBase} ${t.easingStandard};
      pointer-events: none;
    }
    :host([checked]) .uwc-rb__dot { transform: scale(1); }

    /* Focus ring */
    .uwc-rb:focus-within {
      box-shadow: 0 0 0 3px color-mix(in oklab, var(--_color) 25%, transparent);
    }

    /* Hover */
    :host(:not([disabled]):not([checked])) .uwc-rb:hover {
      border-color: var(--_color);
    }

    /* ── Invalid ────────────────────────────────────────────────────────────── */
    :host([invalid]) .uwc-rb {
      border-color: var(--uwc-color-danger, ${t.danger}) !important;
    }

    /* ── Filled variant ─────────────────────────────────────────────────────── */
    :host([variant="filled"]:not([checked])) .uwc-rb {
      --_bg: ${t.surfaceRaised};
      border-color: transparent;
    }

    /* ── Label ──────────────────────────────────────────────────────────────── */
    .uwc-rb__label {
      font-size:   var(--uwc-radio-font-size, ${t.fontSizeMd});
      color:       var(--uwc-radio-label-color, ${t.text});
      line-height: 1.4;
    }
  `,
];
